var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-text',[_c('v-row',[_c('v-col',[_c('export-request-latency-response-chart',{attrs:{"statistics":_vm.statistic}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }